import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";

const root = document.getElementById("root")!;
const app = <App />;
const normalizedPath =
  window.location.pathname === "/"
    ? "/"
    : window.location.pathname.replace(/\/$/, "");

if (
  root.dataset.prerendered === "true" &&
  root.dataset.route === normalizedPath
) {
  hydrateRoot(root, app);
} else {
  root.replaceChildren();
  createRoot(root).render(app);
}
